import colors from './colors';
import { screens, breakpoints } from './breakpoints';
import transition from './transition';
import { CuiSpacing, CuiTheme } from './types';

const spacing: CuiSpacing = {
  '0': 0,
  '1': '1px',
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '16': '16px',
  '20': '20px',
  '24': '24px',
  '32': '32px',
  '36': '36px',
  '40': '40px',
  '48': '48px',
  '52': '52px',
  '56': '56px',
  '64': '64px',
  '72': '72px',
  '76': '76px',
  '80': '80px',
  '96': '96px',
  '104': '104px',
  '112': '112px',
  '120': '120px',
  '144': '144px',
  '160': '160px',
  '200': '200px',
  '212': '212px',
  '280': '280px',
};

const theme: CuiTheme = {
  screens,
  breakpoints,
  colors,
  spacing,
  width: {
    auto: 'auto',
    ...spacing,
    full: '100%',
    screen: '100vw',
  },
  fontFamily: {
    gil: [
      'Gilroy',
      'SF Pro Display',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      'Segoe UI',
      'Helvetica',
      'Arial',
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
    ],
    nun: [
      'Nunito',
      'SF Pro Display',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      'Segoe UI',
      'Helvetica',
      'Arial',
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
    ],
  },
  fontSize: {
    '11': '11px',
    '12': '12px',
    '14': '14px',
    '16': '16px',
    '18': '18px',
    '20': '20px',
    '24': '24px',
    '32': '32px',
    '40': '40px',
    '52': '52px',
    '56': '56px',
    '64': '64px',
  },
  fontWeight: {
    light: '300',
    normal: '400',
    semibold: '600',
    bold: '700',
    extrabold: '800',
  },
  letterSpacing: {
    '0': '0',
    '1': '0.1px',
    '2': '0.2px',
    '4': '0.4px',
    '8': '0.8px',
    '12': '1.2px',
  },
  lineHeight: {
    '12': '12px',
    '14': '14px',
    '16': '16px',
    '18': '18px',
    '20': '20px',
    '22': '22px',
    '24': '24px',
    '28': '28px',
    '32': '32px',
    '40': '40px',
    '44': '44px',
    '48': '48px',
    '60': '60px',
    '64': '64px',
    '68': '68px',
  },
  opacity: {
    '0': '0',
    '28': '0.28',
    '32': '0.32',
    '36': '0.36',
    '40': '0.4',
    '50': '0.5',
    '56': '0.56',
    '80': '0.8',
    '100': '1',
  },
  boxShadow: {
    dropdown: '0px 4px 18px rgba(92, 84, 122, 0.14)',
    snackbar: '0px 10px 16px rgba(92, 84, 122, 0.16)',
    'snackbar-mobile': '0px 5px 14px rgba(92, 84, 122, 0.28)',
    'bottom-nav': '0px -3px 5px rgba(92, 84, 122, 0.15)',
    tooltip: '0px 2px 6px rgba(92, 84, 122, 0.2)',
    card: '0px 8px 18px rgba(92, 84, 122, 0.1)',
    none: 'none',
  },
  transition,
};

export default theme;
